var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g({staticClass:"text-button-with-caret",attrs:{"size":"sm","variant":"link"}},_vm.$listeners),[(_vm.caretPosition === 'left')?_c('b-icon-caret-left-fill',{staticClass:"caret-icon"}):_vm._e(),_vm._t("default"),(_vm.caretPosition === 'right')?_c('b-icon-caret-right-fill',{staticClass:"caret-icon"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }